import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1cfc54c1"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "mine-page container" }
const _hoisted_2 = { class: "mine-left hidden-xs-only" }
const _hoisted_3 = { class: "mine-right" }
const _hoisted_4 = { class: "mine-content" }

import Sidebar from './components/sidebar.vue';
  import { BreadcrumbRoute } from '@/types/breadcrumb-route';
  import { reactive, onMounted, watch } from 'vue';
  import { useRoute } from 'vue-router';
  import { authStore, mineBreadcurmbStore } from '@/stores';
  import { useI18n } from 'vue-i18n';

  
export default /*#__PURE__*/_defineComponent({
  setup(__props) {

  const { t } = useI18n();
  const route = useRoute();
  const defaultRoutes: BreadcrumbRoute[] = [
    { name: t('Home'), to: { name: 'home' } },
    { name: t('My page'), to: { name: 'mine' } },
  ];

  const routes = reactive<BreadcrumbRoute[]>([
    ...defaultRoutes,
    { name: String(route.meta.title || ''), to: { name: route.name || '' } }
  ]);

  const updateRoutes = () => {
    const name = route.name;
    if (name === 'mine.programParticipationDetail') {
      routes.pop();
      routes.push(...[
        { name: t('Collection history'), to: { name: 'mine.collectionHistory' } },
        { name: String(route.meta.title), to: { name: route.name || '' } }
      ]);
    }
  };

  const init = () => {
    authStore.tryFetchData();
    updateRoutes();
  };

  onMounted(init);

  watch(() => mineBreadcurmbStore.data, () => {
    if (route.meta.customBreadcurmb) {
      routes.pop();
      routes.push(...mineBreadcurmbStore.data);
    }
  });

return (_ctx: any,_cache: any) => {
  const _component_AppBreadcurmb = _resolveComponent("AppBreadcurmb")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(Sidebar)
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_AppBreadcurmb, {
        class: "hidden-xs-only",
        routes: _unref(routes)
      }, null, 8, ["routes"]),
      _createElementVNode("div", _hoisted_4, [
        (_openBlock(), _createBlock(_component_router_view, {
          key: _ctx.$route.fullPath
        }))
      ])
    ])
  ]))
}
}

})